module.exports = __webpack_public_path__ + "img/cover.ccd75a08.jpg";